<template>
  <button
      class="emat-btn emat-btn-primary"
      :class="classes"
      type="button"
      @click="performClick"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ButtonPrimary',

  props: {
    /**
     * A boolean specifying whether the button is disabled or not
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * Stretches the button
     */
    btnBlock: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    classes() {
      return {
        disabled: this.disabled,
        'emat-btn-block': this.btnBlock,
      };
    },
  },

  methods: {
    performClick() {
      if (this.disabled) {
        return;
      }

      this.$emit('click');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";

.emat-btn {
  &:active,
  &:visited,
  &:focus {
    border: none;
    outline: none;
  }

  border: none;
  font-size: 1rem;
  cursor: pointer;
  padding: 16px 20px;
  font-family: var(--font);
  box-sizing: border-box;
  border-radius: $border-radius;

  &.emat-btn-primary {
    background-color: var(--c-primary);
    color: $c-white;
    transition: background-color .3s;

    &:hover {
      background-color: var(--c-primary-dark);
    }

    &.disabled {
      background-color: var(--c-primary-light);
    }
  }

  &.emat-btn-block {
    width: 100%;
  }
}
</style>
